<template>
  <FadeIn>
    <figure class="prose">
      <div class="embed" v-html="content.iframe"></div>
      <figcaption v-if="content.caption" class="mt-4 text-xs text-gray-500" v-interpolation v-html="content.caption">
      </figcaption>
    </figure>
  </FadeIn>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
.embed {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
  border-radius: 6px;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}
</style>